'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (Component) {
  var ShareButtonComponent = (0, _memoWithDisplayName2.default)('ShareButton(' + (0, _getComponentName2.default)(Component) + ')', function (props) {
    var buttonRef = props.buttonRef,
        rest = _objectWithoutProperties(props, ['buttonRef']);

    var defaultRef = (0, _react.useRef)(null);

    return _react2.default.createElement(Component, _extends({}, rest, { buttonRef: buttonRef || defaultRef }));
  });

  ShareButtonComponent.propTypes = _extends({}, Component.propTypes, {
    buttonRef: _refObject2.default
  });
  ShareButtonComponent.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(ShareButtonComponent, Component);

  return ShareButtonComponent;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getComponentName = require('react-utils/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _memoWithDisplayName = require('../utils/memoWithDisplayName');

var _memoWithDisplayName2 = _interopRequireDefault(_memoWithDisplayName);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/decorators/ShareButton.js
// module id = 106
// module chunks = 177